import { type ReactNode } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { cn } from '@/utils/commonUtil'

import styles from './ScrollOverflow.module.scss'
import { useScrollOverflow } from './useScrollOverflow'

type Props = {
  activeKey?: string
  children: ReactNode
  fadeSize?: 'sm'
  offset?: number
}

export const ScrollOverflow = ({ activeKey, children, fadeSize, offset }: Props) => {
  const { isScrolling, leftOverflow, ref, rightOverflow, scroll } = useScrollOverflow({ activeKey, offset })

  return (
    <div
      className={cn(styles.container, {
        fadeSize,
        isScrolling,
        leftOverflow,
        rightOverflow,
        styles,
      })}
    >
      <div className={styles.inner} ref={ref}>
        {children}
      </div>
      {leftOverflow && (
        <ButtonRoot
          aria-label='Scroll left'
          className={cn(styles.button, styles.left)}
          onClick={() => scroll('left')}
        />
      )}
      {rightOverflow && (
        <ButtonRoot
          aria-label='Scroll right'
          className={cn(styles.button, styles.right)}
          onClick={() => scroll('right')}
        />
      )}
    </div>
  )
}
